import { useSearchParams } from 'next/navigation';
import { useMemo } from 'react';

import { ScreenKey, ScreenKeysNavParams } from '@constants';

// eslint-disable-next-line @typescript-eslint/no-unused-vars
export const useTypedSearchParams = <SK extends ScreenKey>(route: SK) => {
  const searchParams = useSearchParams();

  const paramsObject = useMemo(() => {
    const params: Record<string, string> = {};

    searchParams?.forEach((value, key) => {
      params[key] = value;
    });

    return params;
  }, [searchParams]);

  return paramsObject as SK extends keyof ScreenKeysNavParams
    ? ScreenKeysNavParams[SK]
    : Record<string, never>;
};
